// extracted by mini-css-extract-plugin
module.exports = {"Input":"Checkbox_Input__2r5KM","Label":"Checkbox_Label__lZwN-","InputElement":"Checkbox_InputElement__PdJvT","Invalid":"Checkbox_Invalid__397tF"};